import { map, values } from "ramda";
import { Maybe } from "true-myth";
import { Schema } from "@upserve/cold-storage";

import {
  excludeEmptySchema,
  maybetype,
  moneytype,
  nameSchema,
  EmptyType,
  ShiftTimeSchema,
} from "helpers/schema";
import { Weekday } from "helpers/dates";
import {
  IPosUser,
  IPerson,
  IPeople,
  IRole,
  IUnavailabilityBlock,
  Category,
  Frequency,
  UnavailType,
} from "types/schedules";
import { IUsersByUuid } from "types/reducers";

const { parseBySchema, propertygroup, jsontype, encodeBySchema } = Schema;

const roleSchema: IRole = {
  uuid: jsontype("string"),
  name: jsontype("string"),
  category: excludeEmptySchema() as Category,
  payRate: maybetype(moneytype("dollars")),
};

const unavailabilityBlockSchema: IUnavailabilityBlock = {
  date: jsontype("date"),
  startTime: propertygroup(ShiftTimeSchema("start")),
  endTime: propertygroup(ShiftTimeSchema("end")),
  frequency: jsontype("string") as Frequency,
  dayOfWeek: jsontype("string") as Weekday,
  parentId: jsontype("string"),
  type: jsontype("string") as UnavailType,
  userId: jsontype("string"),
  uuid: excludeEmptySchema(),
};

const posUserSchema: IPosUser = {
  uuid: jsontype("string"),
  firstName: jsontype("string"),
  lastName: jsontype("string"),
  email: maybetype("string", EmptyType.ELIMINATE_EMPTY),
  phone: maybetype("string", EmptyType.ELIMINATE_EMPTY),
  roles: [roleSchema],
};

function convertToSchedulePerson(posUser: IPosUser): IPerson {
  return {
    assignee: Maybe.of(posUser),
    shifts: [],
    unavail: Maybe.nothing(),
  };
}

nameSchema(unavailabilityBlockSchema, "UnavailabilityBlock");
nameSchema(posUserSchema, "posUserSchema");
const parseUserSchema = parseBySchema(posUserSchema);
const parseUnavailabilitySchema = parseBySchema(unavailabilityBlockSchema);
const encodeUnavailToJSON = encodeBySchema(unavailabilityBlockSchema);

function posUsersToPeople(posUsers: IUsersByUuid): IPeople {
  return map(convertToSchedulePerson)(values(posUsers));
}

export {
  convertToSchedulePerson,
  encodeUnavailToJSON,
  parseUnavailabilitySchema,
  parseUserSchema,
  posUserSchema,
  posUsersToPeople,
  roleSchema,
  unavailabilityBlockSchema,
};
